/** FullScreenLoader — Centered spinner with optional message, used as Suspense fallback. */

import { Box, CircularProgress, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const LoaderContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  width: "100%",
  gap: "1rem"
});

interface FullScreenLoaderProps {
  message?: string;
}

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ message }) => {
  const { t } = useTranslation("base");
  const displayMessage = message || t("eInvoicingApp.loading");

  return (
    <LoaderContainer
      role="status"
      aria-live="polite"
      aria-label={displayMessage}
    >
      <CircularProgress size={48} sx={{ color: "primary.main" }} />
      <Typography variant="bodyText" color="text.secondary">
        {displayMessage}
      </Typography>
    </LoaderContainer>
  );
};

export default FullScreenLoader;
